import { Auth } from 'aws-amplify';

import { LOGIN_STATES } from '@/constants';
import TextInput from '@/components/text-input';
import { ButtonPrimary, ButtonLink } from '@/components/button';
import NotificationService from '@/components/notification-service';
import globalStyles from '@/styles/globals.module.scss';
import styles from '../styles.module.scss';

/**
 * @param {object} params
 * @param {import('formik').FormikProps<null>} params.form
 * @param {(string) => void} params.setState
 * @param {string} params.signUpEmail
 */
const EmailConfirmation = ({ form, setState, signUpEmail }) => {
  if (!form) {
    return null;
  }

  const { values, touched, errors, handleChange, isSubmitting } = form;

  const confirmSignUp = async (email, code) => {
    try {
      await Auth.confirmSignUp(email, code);

      NotificationService.success('Verified');
      return LOGIN_STATES.INITIAL;
    } catch (error) {
      console.log('Confirm Sign Up Error: ', error);
      NotificationService.error(error.message);

      return LOGIN_STATES.CONFIRM_EMAIL;
    }
  };

  const resendSignUp = username => async () => {
    try {
      await Auth.resendSignUp(username);

      NotificationService.info('Resent verification code');
    } catch (err) {
      console.log('Resend Sign Up Error: ', err);
      NotificationService.error(err.message);
    }
  };

  return (
    <div className={styles.loginForm}>
      <p className={styles.loginLabel}>Enter Verification Code</p>

      <TextInput
        id="verificationCode"
        label="Verification Code"
        placeholder="Verification Code"
        value={values.verificationCode}
        isInvalid={touched.verificationCode && !!errors.verificationCode}
        error={errors.verificationCode}
        onChange={handleChange}
        containerClassName={globalStyles.inputContainer}
      />

      <ButtonPrimary
        id="confirmVerificationCode"
        className={styles.submitButton}
        form="loginForm"
        onClick={async () => {
          const newState = await confirmSignUp(
            signUpEmail,
            values.verificationCode
          );
          setState(newState);
        }}
        disabled={isSubmitting}
      >
        Verify
      </ButtonPrimary>

      <div className={styles.formActions}>
        <ButtonLink
          id="backButton"
          className={styles.leftButtonLink}
          onClick={() => {
            setState(LOGIN_STATES.INITIAL);
          }}
        >
          Back
        </ButtonLink>

        <ButtonLink
          className={styles.rightButtonLink}
          onClick={resendSignUp(signUpEmail)}
        >
          Resend Verification
        </ButtonLink>
      </div>
    </div>
  );
};

export default EmailConfirmation;
